import { useContext, createContext } from 'react';
import { types, onSnapshot } from 'mobx-state-tree';

import { Messages } from './Modules/Messages';
import { NotificationRequests } from "./Modules/NotificationRequests";
import { RequestLogs } from "./Modules/RequestLogs";

const RootModel = types.model({
    messages: Messages,
    notificationRequests: NotificationRequests,
    requestLogs: RequestLogs
});

export const rootStore = RootModel.create({
    messages: {
    },
    notificationRequests: {},
    requestLogs: {}
})

onSnapshot(rootStore, snapshot => console.log("Snapshot: ", snapshot))

const RootStoreContext = createContext(RootModel);
export const Provider = RootStoreContext.Provider;
export const useMst = () => {
    const store = useContext(RootStoreContext);
    if (store === null) {
        throw new Error("Store cannot be null, please add a context provider");
    }

    return store;
}
